import Clock from '@/components/Custom/CustomClock';
import Box from '@/components/UI/Box';
import type { FragmentOf } from '@/gql/graphql';
import { EventClockFragment, useEventClock } from './EventClock.utils';

export { EventClockFragment };

interface EventClockProps {
  fragment: FragmentOf<typeof EventClockFragment> | null | undefined;
  isDisabled?: boolean;
  onChange?: (actualElapsedMs: number) => void;
  color?: string;
}

export default function EventClock({
  fragment,
  isDisabled = false,
  onChange,
  color,
}: EventClockProps) {
  const {
    displayMinutes,
    displaySeconds,
    isEffectivelyDisabled,
    handleInputChange,
  } = useEventClock({
    fragment,
    isDisabledExternal: isDisabled,
    onActualElapsedMsChange: onChange,
  });

  return (
    <Box>
      <Clock
        displayMinutes={displayMinutes}
        displaySeconds={displaySeconds}
        onChange={handleInputChange}
        isDisabled={isEffectivelyDisabled}
        color={color}
      />
    </Box>
  );
}
